export default "__VITE_ASSET__D0G$DJkj__"